<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :fields="fields"
    :searchDisable="true"
    @change="change"
    @input="change"
    @changeFunction="changeFunction"
    @deleted="$emit('deleted', true)"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  props: {
    id: {
      default: null,
    },
  },
  created() {
    this.itemLink = `orders/${this.id}/payments`;
    this.setLink = `orders/${this.id}/payments`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {
      console.log("222");
    },
  },
  data() {
    return {
      val: [],
      modalCreate: "payment",
      fields: [
        {
          label: "Сумма оплаты",
          key: "amount",
          type: "field",
          textType: "number",
        },
        {
          label: "Дата оплаты",
          key: "paid_at",
          type: "datetime",
        },
        {
          label: "Комментарий",
          key: "comment",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_payment",
      itemLink: "payments",
      setLink: "payments",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          // sortBy:'id'
        },
        {
          key: "amount",
          title: "Сумма",
        },

        {
          key: "created_at",
          title: "Дата запроса",
          dateTimeFormat: true,
        },
        {
          key: "paid_at",
          title: "Дата оплаты",
          dateTimeFormat: true,
        },
        {
          key: "user",
          object: "name",
          disableLink: true,
          title: "Отвественный",
        },
        {
          key: "comment",
          title: "Коммент",
        },
      ],
    };
  },
};
</script>
